import { BaseRepository } from "@/repositories/base-repository"
import { type IKnownBusinessEntity } from "@/interfaces/api/known-business-entity.interface.ts"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder.ts"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface.ts"
import type { AxiosResponse } from "axios"

export class KnownBusinessEntityRepository extends BaseRepository<IKnownBusinessEntity> {
  protected resourcePath = "core/known-business-entities"

  public async createFromRegistrationNumber(
    data: { countryOfRegistration: string; registrationNumber: string; customName?: string },
    config: IRepositoryRequestConfig = {}
  ): Promise<AxiosResponse<IKnownBusinessEntity>> {
    return await new HTTPRequestBuilder(HTTPMethods.POST, this.getResourcePath(undefined, config))
      .setData(data)
      .query(config.query)
      .setExpectedStatusCode(201)
      .setbeforeErrorHandlingCallback(config.beforeErrorHandlingCallback)
      .addStatusCodeHandlers(config.statusCodeHandlers)
      .build()
      .execute()
  }
}
